import React, { useState, useMemo } from 'react';
import _ from 'lodash';
import { Box, makeStyles } from '@material-ui/core';
import { bedP } from '../../bsApp';
import { onKeyUpEnterOrSpace } from '../../../../utils';
import useCheckLogin from '../../../../utils/useCheckLogin';
import { MdroIcon } from '../../../../components/MdroInfo';
import { isNotEmptyArray, positionRemaks, showPopOptimized } from '../../../../utils/newBedStatusUtil';
import { CmsAlertStandardIcon } from '../../../../components/Icon';
import RemaksIcon from './RemaksIcon';
import RevampStatusBed from './RevampStatusBed';

// Style components
const useStyles = makeStyles(() => ({
  root: ({ cursor, hasCmsAlerts }) => ({
    cursor: cursor,
    position: 'relative',
    width: '100%',
    height: '100%',
    zIndex: hasCmsAlerts ? 11 : 10,
  }),
  top: () => ({
    minHeight: '0.688rem',
    display: 'flex',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 9,
  }),
  left: ({ isVertical, hasTopIcons }) => ({
    // minWidth: isVertical ? '1.1rem' : '0',
    // display: 'flex',
    // flexDirection: isVertical ? 'column' : 'row',

    position: 'absolute',
    left: 0,
    top: hasTopIcons ? '0.288rem' : '0',
    zIndex: 9,
    minWidth: '1.1rem',
    display: 'flex',
    flexDirection: 'column',
  }),
  right: ({ isVertical, hasTopIcons }) => ({
    // display: 'flex',
    // flexDirection: isVertical ? 'column' : 'row',
    // minHeight: isVertical ? 'unset' : '1.1rem',
    // minWidth: isVertical ? '1.1rem' : 'unset',
    // zIndex: 9,

    position: 'absolute',
    right: 0,
    top: hasTopIcons ? '0.288rem' : '0',
    zIndex: 9,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'unset',
    minWidth: '1.1rem',
  }),
  bedContain: ({ isVertical }) => ({
    // display: 'flex',
    // flexDirection: isVertical ? 'row' : 'column-reverse',
    position: 'absolute',
    left: 0,
    right: 0,
    top: '0.4rem',
  }),
  mdroIconContain: ({ isVertical }) => ({
    // marginLeft: isVertical ? '-0.857rem' : '',
    // marginBottom: isVertical ? '' : '-0.857rem',
    // display: 'flex',
    // flexDirection: isVertical ? 'column' : 'row',
    // zIndex: 9,

    marginLeft: '-0.857rem',
    marginBottom: '',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 9,
  }),
  cmsAlert: {
    width: '1.85rem',
    height: '1.6rem',
    marginLeft: '-0.68rem',
    marginTop: '-0.2rem',
    zIndex: 9,
  },
}));

// Main component
export default function RevampBedStatusIcon({
  id,
  allData,
  disabled,
  status,
  updateBedStatus,
  saveBedStatus,
  saveReturnDayCase,
  ward,
  editFloorPlan = false,
  reload,
  showPatientName = false,
  isMutipleWardCode,
}) {
  const gender = allData?.patGender; // 病人的性别 -> 对应api的patGender字段
  const bedNo = allData?.bedNo; // 病人的床号 -> 对应api的bedNo字段
  // 床头不是左右都当成竖向,或者点了showPatientName,都设为竖向, 否则是横向
  const isVertical = showPatientName || !['right', 'left']?.includes(allData?.bedHead);
  // 根据床横竖向调整右列icon的排列方向
  const checkLogin = useCheckLogin();
  const [IsPop, setIsPop] = useState(false);
  const closePop = () => {
    setIsPop(false);
  };
  const openPop = () => {
    if (checkLogin()) {
      !disabled && setIsPop(true);
    }
  };

  // 获取床位状态对应的icon显示的位置
  const statusIcons = useMemo(
    () => positionRemaks(allData, editFloorPlan, RemaksIcon),
    [allData, editFloorPlan, RemaksIcon]
  );
  const lefts = statusIcons.left();
  const rights = statusIcons.right();
  const tops = statusIcons.top();
  const hasTopIcons = Array.isArray(tops) && tops?.length !== 0;
  const hasCmsAlerts = isNotEmptyArray(allData?.[bedP?.cmsAlertInfos]);

  const classes = useStyles({
    absolute: 'absolute',
    cursor: disabled ? 'unset' : 'pointer',
    isVertical,
    hasTopIcons,
    hasCmsAlerts,
  });

  return (
    <>
      <div
        id={id}
        className={classes.root}
        onClick={openPop}
        tabIndex={0}
        onKeyUp={(e) => onKeyUpEnterOrSpace(e, openPop)}
      >
        <div className={classes.top}>{tops}</div>
        <Box className={classes.bedContain}>
          <Box className={classes.left}>{lefts}</Box>
          <RevampStatusBed
            genderType={gender}
            bedNo={bedNo}
            ward={ward}
            allData={allData}
            editFloorPlan={editFloorPlan}
            isVertical={isVertical}
            showPatientName={showPatientName}
            status={status}
            isMutipleWardCode={isMutipleWardCode}
          />
          <Box className={classes.right}>
            {rights}
            <Box className={classes.mdroIconContain}>
              {_.map(_.orderBy(allData?.[bedP.mdroInfo], ['alertDesc'], ['asc']), (item, index) => (
                <MdroIcon
                  value={item.alertDesc}
                  confirmedInd={item.confirmedInd}
                  width="2rem"
                  height="fit-content"
                  fontSize="0.542rem"
                  type="bedstatus"
                  key={`${item.rowkey}-${index}`}
                />
              ))}
            </Box>
            {isNotEmptyArray(allData?.[bedP?.cmsAlertInfos]) && <CmsAlertStandardIcon className={classes.cmsAlert} />}
          </Box>
        </Box>
      </div>
      {IsPop &&
        showPopOptimized({
          allData,
          showPopup: IsPop,
          updateBedStatus,
          closePop,
          saveBedStatus,
          saveReturnDayCase,
          reload,
        })}
    </>
  );
}
